import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui' 
import 'element-ui/lib/theme-chalk/index.css'
import VueAMap from 'vue-amap'
import $ from 'jquery'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(VueAMap)
 
VueAMap.initAMapApiLoader({
  key: 'cfa5a6745eab925fe992a7436de75e74',
  plugin: [//高德地图扩展插件(按需添加)
    'AMap.Autocomplete', // 输入提示插件
    'AMap.PlaceSearch', // POI搜索插件
    'AMap.Scale', // 右下角缩略图插件 比例尺
    'AMap.OverView', // 地图鹰眼插件
    'AMap.ToolBar', // 地图工具条
    'AMap.MapType', // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    'AMap.PolyEditor', // 编辑 折线多，边形
    'AMap.CircleEditor', // 圆形编辑器插件
    'AMap.Geolocation' // 定位控件，用来获取和展示用户主机所在的经纬度位置
  ],
  uiVersion: '1.1', // ui库版本，不配置不加载,
  v: '2.0'
})



router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)){ // 判断该路由是否需要登录权限
	// console.log(localStorage.oid);
    if (localStorage.oid) { // 判断当前的user_id是否存在 ； 登录存入的user_id
      next();
    }
    else {
      next({
        path: '/',
        query: {redirect: to.fullPath} // 将要跳转路由的path作为参数，传递到登录页面
      })
    }
  }
  else {
    next();
  }
})



new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

